module.exports = __webpack_public_path__ + "media/images/comment-08f0f0de74f6b732fec3287813eba16f.svg";